$(function () {
    const videoPlaceholders = document.querySelectorAll(".video-placeholder");

    videoPlaceholders.forEach((placeholder) => {
        placeholder.addEventListener("click", function () {
            const videoId = placeholder.getAttribute("data-video-id");

            const iframe = document.createElement("iframe");
            iframe.setAttribute("width", "560");
            iframe.setAttribute("height", "315");
            iframe.setAttribute(
                "src",
                `https://www.youtube.com/embed/${videoId}?controls=1&autoplay=1`
            );
            iframe.setAttribute("frameborder", "0");
            iframe.setAttribute(
                "allow",
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            );
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");

            const parent = placeholder.parentElement;
            parent.innerHTML = "";
            parent.appendChild(iframe);
        });
    });

    const contentSliderSettings = {
        dots: false,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        infinite: false,
        speed: 500,
        slidesToShow: 1.05,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        mobileFirst: true,
        accessibility: true,
        draggable: true,
        adaptiveHeight:true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    dots: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    adaptiveHeight:false,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    dots: false,
                    slidesToShow: 2.2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1700,
                settings: {
                    slidesToShow: 2.7,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    let contentSlider = $('.testimonials-content-slider').slick(contentSliderSettings);

    $(window).resize(function () {
        contentSlider.not( '.slick-initialized' ).slick(contentSliderSettings);
        let iframes = document.querySelectorAll('.testimonials-section iframe');

        iframes.forEach(iframe => {
            iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
        });
    });

});
